import templateUrl from "emun.on-demand/media/add-media-prompt.htm";
import AddMediaPromptController from "emun.on-demand/media/add-media-prompt.controller";
import open from "webmodals/open";

let addMediaPrompt = options => {
  let modalInstance = open({
    size: options.size || "lg",
    backdrop: "static",
    templateUrl: options.templateUrl || templateUrl,
    controller: AddMediaPromptController,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      options: () => options
    }
  });

  return modalInstance.result;
};

export default addMediaPrompt;
